import axios from 'axios';

const API_URL = 'https://api.teamleetcoders.in/api';

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add response interceptor for better debugging
api.interceptors.response.use(
  (response) => {
    console.log(`API Success [${response.config.url}]:`, response.data);
    return response;
  },
  (error) => {
    console.error('API Error:', error.response ? error.response.data : error.message);
    return Promise.reject(error);
  }
);

// Search users
export const searchUsers = async (params) => {
  try {
    console.log('Sending search request with params:', params);
    const response = await api.get('/search', { params });
    return response.data;
  } catch (error) {
    console.error('Error searching users:', error);
    // Add more detailed error info
    const errorMsg = error.response 
      ? `Server responded with ${error.response.status}: ${JSON.stringify(error.response.data)}`
      : `Network error: ${error.message}`;
    console.error(errorMsg);
    throw error;
  }
};

// Get user by ID
export const getUserById = async (id) => {
  try {
    console.log('Fetching user details for ID:', id);
    const response = await api.get(`/search/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error getting user:', error);
    throw error;
  }
};

export default api; 
